import classNames from 'classnames';
import React from 'react';

import { format as formatDate } from '@eika-infrastruktur/date';
import { RowButton } from '@eika/button';

import { SelectList } from '../../components/shared/SelectList';
import type { PaymentItem, PaymentType } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import TranslationsConfigType from '../../translations/translationType';
import { paymentTrackIDs } from '../../utils/gtm/trackIDs/payment';
import PaymentListItemContent from './PaymentListItemContent';
import { FormattedPaymentItem, FormattedPayments } from './formatPaymentItems';

type Props = {
    items: FormattedPayments[];
    onClick: (value?: PaymentItem) => void;
    className?: string;
};

const getAriaLabel = (payment: FormattedPaymentItem, paymentTypeText: string) => {
    const date = formatDate(payment.dueDate, 'd. MMMM yyyy');
    return `${paymentTypeText} kr ${payment.amountFormatted} ${date}`;
};

const getDataTrackLinkName = (paymentType: PaymentType | undefined, translated: TranslationsConfigType) => {
    const translatedType = paymentType
        ? translated.futurePaymentType[paymentType]
        : translated.futurePaymentType.PAYMENT;
    return translatedType.replace(/\s/g, '-').toLowerCase();
};

function PaymentList({ items, onClick, className }: Props) {
    const translated = useTranslation();
    return (
        <section className={classNames('future-payments-list__wrapper', className)}>
            <ul className="future-payments-list__container additional-padding">
                {items.map((item) => (
                    <li key={`${item.id}-${item.label}`} className="future-payments-list-month__container">
                        <div className={classNames('future-payments-list-month__label-and-amount')}>
                            <div className="future-payments-list-month__label bold">{item.label}</div>
                        </div>
                        <SelectList>
                            {item.paymentItems.map((payment) => (
                                <li key={payment.id.value}>
                                    <RowButton
                                        onClick={() => onClick(payment.paymentItem)}
                                        aria-label={getAriaLabel(payment, translated.paymentItemStatus[payment.status])}
                                        data-testid="stopped-payment-item"
                                        data-track-id={paymentTrackIDs.stopped.paymentItem}
                                        data-track-linkname={getDataTrackLinkName(
                                            payment.paymentItem.paymentItemType,
                                            translated,
                                        )}
                                    >
                                        <PaymentListItemContent payment={payment} />
                                    </RowButton>
                                </li>
                            ))}
                        </SelectList>
                    </li>
                ))}
            </ul>
        </section>
    );
}

export default PaymentList;
